import React from 'react';
import { APITypes } from '../../../../primary-record-types';
import _isEqual from 'lodash/isEqual';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import AttachmentListItem from '../AttachmentListItem';

export type AttachmentListOwnProps = {
    note: APITypes.notesService.NoteDetails;
};

export type AttachmentListProps = AttachmentListOwnProps;

const AttachmentList: React.FC<AttachmentListProps> = (props) => {
    const maybeGetFileMedicalProfileFile = (fileId: string): APITypes.notesService.NoteMedicalProfileFile | null => {
        return props.note.medicalProfileFiles.find((file) => file.sourceFileId === fileId) || null;
    };

    return (
        <Stack vertical fullWidth space={contentStackSpacing}>
            {props.note.images.map((image) => (
                <AttachmentListItem
                    key={image.noteFileId}
                    file={{
                        type: 'image',
                        fileId: image.noteFileId,
                        noteId: props.note.noteId,
                    }}
                    description={image.description}
                    medicalProfileFile={maybeGetFileMedicalProfileFile(image.noteFileId)}
                />
            ))}
            {props.note.files.map((file) => (
                <AttachmentListItem
                    key={file.noteFileId}
                    file={{
                        type: 'file',
                        fileId: file.noteFileId,
                        noteId: props.note.noteId,
                    }}
                    description={file.description}
                    medicalProfileFile={maybeGetFileMedicalProfileFile(file.noteFileId)}
                />
            ))}
        </Stack>
    );
};

export default React.memo(AttachmentList);
